import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import "./interview.css";
import { apiService } from '../../../../services/apiService';

function CreateInterview() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginatedata, setPaginateData] = useState({});
    const { id } = useParams();
    
    const fetchPreviewData = useCallback(async (params = {}) => {
        try {
            const defaultParams = {...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            
            const response = await apiService.getRequest(`/interview-services?${queryString}`);
            
            if (response && response.success === true) {
                setAllData(response.data);
                setPaginateData(response.meta);
            } else {
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, []); // Add isActive to dependency array

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchPreviewData({ page: newPage });
    };

    useEffect(() => {
        fetchPreviewData();
    }, [fetchPreviewData]);
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Interviews Booking</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/catalogs/consulting-services")}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/catalogs/interviews-opportunity")}>Interviews Booking</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Interviews List</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="my-4">
                    {/* <Grid size={{md:5,xs:12}} container flexDirection="column">
                        <div className='d-flex jobseekersearch my-3'>
                            <div className='col-2'>
                                <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                            </div>
                            <div className='col-7'>
                                <input type='text' placeholder='search'
                                    // value={searchQuery}
                                    // onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                            </div>
                            <div className='col-3'>
                                <button 
                                // onClick={handleSearch}
                                >Search</button>
                            </div>
                        </div>
                    </Grid> */}
                    <Grid size={{xs:12}} container className="mt-4 gap-md-4">
                        {loading ? 
                        <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        {allData && allData.length > 0 ? (
                        allData && allData.map((interviews, index) => (
                            <Grid key={index} size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_interviewgrids mt-3">
                                <div className='d-flex flex-wrap justify-content-between align-items-center'>
                                    <img src={require("../../../../assets/catalog/interview_icon.svg").default} alt=''/>
                                    <div className='d-flex flex-wrap interview_hourset'>
                                    <span><FontAwesomeIcon icon={faClock} /> {interviews.duration}</span>
                                    <h5>${interviews.amount}</h5>
                                    </div>
                                </div>
                                <h6 className='mt-3 fw-semibold'>{interviews.description}</h6>
                                <span>{interviews.title}</span>
                                <Link to={`/catalogs/interviews-slot/${interviews.id}/${id}`} className='link_btn_secondary w-100 mt-4 mb-2'>Select</Link>
                            </Grid>
                        ))
                        ) : (<div className='w-100 d-flex flex-column align-items-center'>
                            <p>No Data</p>
                            </div>
                        )}</>}


                        <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage - 1)} 
                                disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            {paginatedata && (
                                <div className="pagination">
                                    {(() => {
                                    const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                                    const pages = [];
                                    const start = Math.max(2, currentPage - 2);
                                    const end = Math.min(totalPages - 1, currentPage + 2);

                                    // Always show first page
                                    pages.push(
                                        <button
                                        key={1}
                                        onClick={() => handlePageChange(1)}
                                        className={currentPage === 1 ? 'active' : ''}
                                        >
                                        1
                                        </button>
                                    );

                                    if (start > 2) {
                                        pages.push(<span key="start-ellipsis">...</span>);
                                    }

                                    for (let i = start; i <= end; i++) {
                                        pages.push(
                                        <button
                                            key={i}
                                            onClick={() => handlePageChange(i)}
                                            className={currentPage === i ? 'active' : ''}
                                        >
                                            {i}
                                        </button>
                                        );
                                    }

                                    if (end < totalPages - 1) {
                                        pages.push(<span key="end-ellipsis">...</span>);
                                    }

                                    if (totalPages > 1) {
                                        pages.push(
                                        <button
                                            key={totalPages}
                                            onClick={() => handlePageChange(totalPages)}
                                            className={currentPage === totalPages ? 'active' : ''}
                                        >
                                            {totalPages}
                                        </button>
                                        );
                                    }

                                    return pages;
                                    })()}
                                </div>
                                )}


                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage + 1)} 
                                disabled={currentPage === paginatedata.last_page}>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </Grid>
                        {/* <Grid size={{md:3.8,xs:12}} container flexDirection="column" justifyContent="space-between" className="grid_interviewgrids mt-3">
                            <div className='d-flex flex-wrap justify-content-between align-items-center'>
                                <img src={require("../../../../assets/catalog/interview_icon.svg").default} alt=''/>
                                <div className='d-flex flex-wrap interview_hourset'>
                                <span><FontAwesomeIcon icon={faClock} /> 1 hr</span>
                                <h5>$50.00</h5>
                                </div>
                            </div>
                            <h6 className='mt-3 fw-semibold'>Interview Consultation - 1 hour</h6>
                            <span>An industry expert will assist you with tips and strategies to ace your next tech interview. This Mock Interview session will prep you...</span>
                            <button onClick={()=> navigate("/catalogs/interviews-slot")} className='registersendbtn1 w-100 mt-4 mb-2'>Select</button>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default CreateInterview
